/*
  Formularele proprii aBeauty, partea din browser.

  Principiul: formularul functioneaza si fara scriptul asta. HTML-ul e un `<form
  method="post">` catre serviciu, iar serverul intoarce omul pe pagina cu
  ?trimis=1. Scriptul doar imbunatateste: validare pe masura ce scrii, incarcare
  a fisierelor cu bara de progres, mesaj de succes fara reincarcare, si salvarea
  a ce ai scris in caz de refresh.

  Fara dependinte, fara framework. ES5 la nivel de sintaxa, ca sa mearga si in
  browserul din aplicatia Facebook pe iOS, de unde vine o parte din trafic.
*/
(function () {
  'use strict';

  if (window.__abeautyFormular) return;
  window.__abeautyFormular = true;

  var TARI_FRECVENTE = ['RO', 'MD'];
  /* Sub atat, serverul considera completarea facuta de o masina. Il tinem si
     aici doar ca sa trimitem durata; nu blocam nimic in browser. */
  var CHEIE_CIORNA = 'abf:ciorna:';

  document.addEventListener('DOMContentLoaded', function () {
    var radacini = document.querySelectorAll('[data-abf]');
    for (var i = 0; i < radacini.length; i++) initFormular(radacini[i]);
  });

  function initFormular(radacina) {
    var form = radacina.querySelector('[data-abf-form-el]');
    if (!form) return;

    var slug = radacina.getAttribute('data-abf-form') || '';
    var endpoint = (radacina.getAttribute('data-abf-endpoint') || '').replace(/\/$/, '');
    var doneBox = radacina.querySelector('[data-abf-done]');
    var failBox = radacina.querySelector('[data-abf-fail]');
    var buton = form.querySelector('[type="submit"]');
    var durata = form.querySelector('[name="_durata"]');
    var pornit = Date.now();

    /* Serverul ne-a intors deja pe pagina dupa o trimitere fara JavaScript. */
    var params = new URLSearchParams(window.location.search);
    if (params.get('trimis') === '1') {
      arataSucces(radacina, form, doneBox, null);
      stergeCiorna(slug);
      curataUrl();
      return;
    }
    if (params.get('eroare') === '1') {
      arataEsec(failBox, mesaje(radacina).esec);
      curataUrl();
    }

    pregatesteTelefoane(form);
    pregatesteContoare(form);
    pregatesteFisiere(form, slug, endpoint);
    pregatesteValidare(form);
    incarcaCiorna(form, slug);

    form.addEventListener('submit', function (event) {
      /* Fara fetch (browser foarte vechi), lasam trimiterea clasica sa mearga. */
      if (!window.fetch || !window.FormData) return;

      event.preventDefault();
      if (durata) durata.value = String(Date.now() - pornit);

      var greseli = valideazaTot(form);
      if (greseli) {
        focuseazaPrimaGreseala(form);
        arataEsec(failBox, mesaje(radacina).lipsa);
        return;
      }

      trimite(radacina, form, slug, endpoint, buton, doneBox, failBox);
    });
  }

  /* ------------------------------------------------------------------ trimitere */

  function trimite(radacina, form, slug, endpoint, buton, doneBox, failBox) {
    ascunde(failBox);
    blocheazaButonul(buton, true);

    var date = culegeDate(form);

    fetch(endpoint + '/api/submit/' + encodeURIComponent(slug), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(date)
    })
      .then(function (raspuns) {
        return raspuns.json().then(function (corp) {
          return { stare: raspuns.status, corp: corp };
        });
      })
      .then(function (rezultat) {
        blocheazaButonul(buton, false);

        if (rezultat.stare >= 200 && rezultat.stare < 300 && rezultat.corp.ok) {
          stergeCiorna(slug);
          arataSucces(radacina, form, doneBox, rezultat.corp.message);
          return;
        }

        pictezaGreseli(form, rezultat.corp.errors || {});
        arataEsec(failBox, rezultat.corp.message || mesaje(radacina).netrimis);
        focuseazaPrimaGreseala(form);
      })
      .catch(function () {
        blocheazaButonul(buton, false);
        /* Reteaua a cazut. Trimiterea clasica e ultima plasa de siguranta: ce a
           completat omul nu se pierde, doar se reincarca pagina. */
        arataEsec(
          failBox,
          mesaje(radacina).retea
        );
        setTimeout(function () {
          form.removeAttribute('novalidate');
          HTMLFormElement.prototype.submit.call(form);
        }, 1200);
      });
  }

  function culegeDate(form) {
    var campuri = {};
    var uploads = {};
    var capcana = '';
    var durata = null;

    var elemente = form.elements;
    for (var i = 0; i < elemente.length; i++) {
      var el = elemente[i];
      if (!el.name || el.disabled) continue;

      if (el.name === '_capcana') {
        capcana = el.value;
        continue;
      }
      if (el.name === '_durata') {
        durata = Number(el.value) || null;
        continue;
      }
      if (el.name.indexOf('_fisier_') === 0) {
        if (el.value) {
          var camp = el.name.slice('_fisier_'.length);
          uploads[camp] = uploads[camp] || {};
          uploads[camp].key = el.value;
        }
        continue;
      }
      if (el.name.indexOf('_nume_fisier_') === 0) {
        if (el.value) {
          var camp2 = el.name.slice('_nume_fisier_'.length);
          uploads[camp2] = uploads[camp2] || {};
          uploads[camp2].name = el.value;
        }
        continue;
      }
      if (el.type === 'file') continue;

      if (el.type === 'checkbox') {
        if (el.checked) campuri[el.name] = 'on';
        continue;
      }
      if (el.type === 'radio') {
        if (el.checked) campuri[el.name] = el.value;
        continue;
      }

      campuri[el.name] = el.value;
    }

    /* Telefonul pleaca in forma internationala, construita din prefix + numar. */
    var telefoane = form.querySelectorAll('input[type="tel"]');
    for (var t = 0; t < telefoane.length; t++) {
      var tel = telefoane[t];
      var selectTara = form.querySelector('[name="' + tel.name + '_tara"]');
      if (!selectTara || !tel.value) continue;
      campuri[tel.name] = e164(selectTara.value, tel.value);
      delete campuri[tel.name + '_tara'];
    }

    return { fields: campuri, uploads: uploads, honeypot: capcana, elapsedMs: durata };
  }

  /* ------------------------------------------------------------------- fisiere */

  function pregatesteFisiere(form, slug, endpoint) {
    var zone = form.querySelectorAll('[data-abf-file]');

    for (var i = 0; i < zone.length; i++) {
      (function (zona) {
        var camp = zona.getAttribute('data-abf-file');
        var maxim = Number(zona.getAttribute('data-abf-max')) || 10485760;
        /* Cutia de eroare NU e in `.abf-file`, ci in campul parinte. Fara
           `closest`, `greseala()` si `curataGreseala()` cauta intr-un subarbore
           unde nu exista: eroarea de fisier nu s-ar afisa niciodata, iar cea
           pusa la validare ar ramane pe ecran si dupa incarcarea reusita. */
        var campEl = zona.closest('[data-abf-field]') || zona;
        var input = zona.querySelector('.abf-file__input');
        var ales = zona.querySelector('.abf-file__chosen');
        var numeEl = zona.querySelector('.abf-file__name');
        var drop = zona.querySelector('.abf-file__drop');
        var fill = zona.querySelector('.abf-file__fill');
        var sterge = zona.querySelector('.abf-file__remove');
        var cheia = form.querySelector('[name="_fisier_' + camp + '"]');
        var numele = form.querySelector('[name="_nume_fisier_' + camp + '"]');

        function reseteaza() {
          input.value = '';
          cheia.value = '';
          numele.value = '';
          ascunde(ales);
          ales.removeAttribute('data-abf-ready');
          if (fill) fill.style.width = '0';
          arata(drop);
        }

        function preia(fisier) {
          if (!fisier) return;

          if (fisier.size > maxim) {
            greseala(campEl, 'Fi\u0219ierul dep\u0103\u0219e\u0219te ' + Math.round(maxim / 1048576) + ' MB.');
            reseteaza();
            return;
          }

          curataGreseala(campEl);
          numeEl.textContent = fisier.name;
          arata(ales);
          ascunde(drop);
          if (fill) fill.style.width = '8%';

          incarca(fisier, slug, camp, endpoint, function (procent) {
            if (fill) fill.style.width = Math.max(8, procent) + '%';
          })
            .then(function (rezultat) {
              cheia.value = rezultat.key;
              numele.value = fisier.name;
              ales.setAttribute('data-abf-ready', '');
              curataGreseala(campEl);
            })
            .catch(function (eroare) {
              greseala(campEl, eroare && eroare.message ? eroare.message : 'Fi\u0219ierul nu s-a \u00eenc\u0103rcat. \u00cencearc\u0103 din nou.');
              reseteaza();
            });
        }

        input.addEventListener('change', function () {
          preia(input.files && input.files[0]);
        });

        sterge.addEventListener('click', reseteaza);

        /* Trage si lasa, doar pe desktop. Pe telefon nu exista, deci nu costa nimic. */
        ['dragenter', 'dragover'].forEach(function (nume) {
          drop.addEventListener(nume, function (event) {
            event.preventDefault();
            zona.setAttribute('data-abf-over', '');
          });
        });
        ['dragleave', 'drop'].forEach(function (nume) {
          drop.addEventListener(nume, function (event) {
            event.preventDefault();
            zona.removeAttribute('data-abf-over');
          });
        });
        drop.addEventListener('drop', function (event) {
          var fisiere = event.dataTransfer && event.dataTransfer.files;
          if (fisiere && fisiere.length) preia(fisiere[0]);
        });
      })(zone[i]);
    }
  }

  /*
    Cere serverului un URL presemnat, apoi pune fisierul direct in stocare.
    XMLHttpRequest, nu fetch: doar el da progresul incarcarii, iar pe 4G bara aia
    e diferenta dintre „se intampla ceva" si „s-a blocat".
  */
  function incarca(fisier, slug, camp, endpoint, laProgres) {
    return fetch(endpoint + '/api/upload-url', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ form: slug, field: camp, size: fisier.size, type: fisier.type })
    })
      .then(function (raspuns) {
        return raspuns.json().then(function (corp) {
          if (!raspuns.ok) throw new Error(corp.error || 'Nu am putut preg\u0103ti \u00eenc\u0103rcarea.');
          return corp;
        });
      })
      .then(function (pregatire) {
        return new Promise(function (rezolva, respinge) {
          var cerere = new XMLHttpRequest();
          cerere.open('PUT', pregatire.uploadUrl, true);
          cerere.setRequestHeader('Content-Type', pregatire.contentType);

          cerere.upload.onprogress = function (event) {
            if (event.lengthComputable && laProgres) {
              laProgres(Math.round((event.loaded / event.total) * 100));
            }
          };
          cerere.onload = function () {
            if (cerere.status >= 200 && cerere.status < 300) {
              if (laProgres) laProgres(100);
              rezolva({ key: pregatire.key });
            } else {
              respinge(new Error('Fi\u0219ierul nu s-a \u00eenc\u0103rcat. \u00cencearc\u0103 din nou.'));
            }
          };
          cerere.onerror = function () {
            respinge(new Error('Conexiunea s-a \u00eentrerupt \u00een timpul \u00eenc\u0103rc\u0103rii.'));
          };
          cerere.send(fisier);
        });
      });
  }

  /* ------------------------------------------------------------------ validare */

  /* Doua tonuri: "tu", tonul site-ului, si "dvs", pentru formularele cu formulare ceruta de
     lege (retragerea din contract). Tonul vine din atributul data-abf-ton al radacinii,
     emis de sectiune din definitie. Diacriticele sunt scrise ca escape-uri, ca fisierul sa
     ramana ASCII si textul sa iasa corect oricum ar fi servit. */
  var MESAJE = {
    tu: {
      gol: 'Te rug\u0103m s\u0103 completezi acest c\u00e2mp.',
      alege: 'Te rug\u0103m s\u0103 alegi o op\u021biune.',
      email: 'Adresa de email nu pare corect\u0103. Verific-o, te rug\u0103m.',
      telefon: 'Num\u0103rul de telefon nu pare corect pentru \u021bara aleas\u0103.',
      bifa: 'Te rug\u0103m s\u0103 bifezi acordul, ca s\u0103 putem prelucra datele.',
      fisier: 'Te rug\u0103m s\u0103 ata\u0219ezi un fi\u0219ier.',
      esec: 'Nu am putut trimite formularul. Verific\u0103 datele \u0219i \u00eencearc\u0103 din nou.',
      lipsa: 'Mai avem nevoie de c\u00e2teva lucruri. Am marcat c\u00e2mpurile.',
      retea: 'Conexiunea a c\u0103zut. \u00cencerc\u0103m din nou trimiterea obi\u0219nuit\u0103, te rug\u0103m s\u0103 nu \u00eenchizi pagina.',
      netrimis: 'Nu am putut trimite formularul.'
    },
    dvs: {
      gol: 'V\u0103 rug\u0103m s\u0103 completa\u021bi acest c\u00e2mp.',
      alege: 'V\u0103 rug\u0103m s\u0103 alege\u021bi o op\u021biune.',
      email: 'Adresa de email nu pare corect\u0103. V\u0103 rug\u0103m s\u0103 o verifica\u021bi.',
      telefon: 'Num\u0103rul de telefon nu pare corect pentru \u021bara aleas\u0103.',
      bifa: 'V\u0103 rug\u0103m s\u0103 bifa\u021bi acordul, ca s\u0103 putem prelucra datele.',
      fisier: 'V\u0103 rug\u0103m s\u0103 ata\u0219a\u021bi un fi\u0219ier.',
      esec: 'Nu am putut trimite declara\u021bia. V\u0103 rug\u0103m s\u0103 verifica\u021bi datele \u0219i s\u0103 \u00eencerca\u021bi din nou.',
      lipsa: 'Mai avem nevoie de c\u00e2teva date. Am marcat c\u00e2mpurile.',
      retea: 'Conexiunea a c\u0103zut. \u00cencerc\u0103m din nou trimiterea obi\u0219nuit\u0103, v\u0103 rug\u0103m s\u0103 nu \u00eenchide\u021bi pagina.',
      netrimis: 'Nu am putut trimite declara\u021bia.'
    }
  };

  function mesaje(el) {
    var radacina = el && el.closest ? el.closest('[data-abf]') : null;
    return MESAJE[radacina && radacina.getAttribute('data-abf-ton') === 'dvs' ? 'dvs' : 'tu'];
  }

  function pregatesteValidare(form) {
    var campuri = form.querySelectorAll('[data-abf-field]');

    for (var i = 0; i < campuri.length; i++) {
      (function (camp) {
        var control = camp.querySelector('input, select, textarea');
        if (!control) return;

        /* Validam la iesirea din camp, nu la fiecare tasta: altfel omul vede
           „email invalid" dupa prima litera scrisa, ceea ce e doar enervant. */
        control.addEventListener('blur', function () {
          verifica(camp);
        });

        /* Dupa ce a fost marcat gresit, corectam din mers, ca eroarea sa dispara
           imediat ce devine adevarat. */
        control.addEventListener('input', function () {
          if (camp.hasAttribute('data-abf-invalid')) verifica(camp);
        });
        control.addEventListener('change', function () {
          if (camp.hasAttribute('data-abf-invalid')) verifica(camp);
        });
      })(campuri[i]);
    }
  }

  function verifica(camp) {
    var mesaj = mesajPentru(camp);
    if (mesaj) greseala(camp, mesaj);
    else curataGreseala(camp);
    return !mesaj;
  }

  function mesajPentru(camp) {
    var form = camp.closest('form');
    var nume = camp.getAttribute('data-abf-field');

    var fisier = camp.querySelector('[data-abf-file]');
    if (fisier) {
      var input = camp.querySelector('.abf-file__input');
      var cheia = form.querySelector('[name="_fisier_' + nume + '"]');
      if (input && input.required && (!cheia || !cheia.value)) return mesaje(camp).fisier;
      return null;
    }

    var bifa = camp.querySelector('input[type="checkbox"]');
    if (bifa) return bifa.required && !bifa.checked ? mesaje(camp).bifa : null;

    var radiouri = camp.querySelectorAll('input[type="radio"]');
    if (radiouri.length) {
      var cerut = false;
      var bifat = false;
      for (var r = 0; r < radiouri.length; r++) {
        if (radiouri[r].required) cerut = true;
        if (radiouri[r].checked) bifat = true;
      }
      return cerut && !bifat ? mesaje(camp).alege : null;
    }

    var control = camp.querySelector('input, select, textarea');
    if (!control) return null;

    var valoare = (control.value || '').trim();

    if (!valoare) {
      if (!control.required) return null;
      return control.tagName === 'SELECT' ? mesaje(camp).alege : mesaje(camp).gol;
    }

    if (control.type === 'email' && !/^[^\s@]+@[^\s@,]+\.[a-z]{2,}$/i.test(valoare)) {
      return mesaje(camp).email;
    }

    if (control.type === 'tel') {
      var selectTara = form.querySelector('[name="' + control.name + '_tara"]');
      var tara = selectTara ? selectTara.value : 'RO';
      if (!telefonPlauzibil(tara, valoare)) return mesaje(camp).telefon;
    }

    return null;
  }

  function valideazaTot(form) {
    var campuri = form.querySelectorAll('[data-abf-field]');
    var greseli = 0;
    for (var i = 0; i < campuri.length; i++) {
      if (!verifica(campuri[i])) greseli++;
    }
    return greseli;
  }

  function pictezaGreseli(form, erori) {
    for (var nume in erori) {
      if (!Object.prototype.hasOwnProperty.call(erori, nume)) continue;
      var camp = form.querySelector('[data-abf-field="' + nume + '"]');
      if (camp) greseala(camp, erori[nume]);
    }
  }

  function greseala(camp, mesaj) {
    var cutie = camp.querySelector('.abf-err');
    camp.setAttribute('data-abf-invalid', '');
    if (cutie) {
      cutie.textContent = mesaj;
      cutie.hidden = false;
    }
    var control = camp.querySelector('input, select, textarea');
    if (control) control.setAttribute('aria-invalid', 'true');
  }

  function curataGreseala(camp) {
    var cutie = camp.querySelector('.abf-err');
    camp.removeAttribute('data-abf-invalid');
    if (cutie) {
      cutie.textContent = '';
      cutie.hidden = true;
    }
    var control = camp.querySelector('input, select, textarea');
    if (control) control.removeAttribute('aria-invalid');
  }

  function focuseazaPrimaGreseala(form) {
    var camp = form.querySelector('[data-abf-invalid]');
    if (!camp) return;
    var control = camp.querySelector('input, select, textarea');
    if (control) {
      if (control.classList.contains('abf-file__input')) {
        var eticheta = camp.querySelector('.abf-file__drop');
        if (eticheta) eticheta.scrollIntoView({ block: 'center' });
      } else {
        control.focus();
      }
    }
    camp.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }

  /* ------------------------------------------------------------------- telefon */

  function prefixe() {
    return window.ABEAUTY_TEL_PREFIXE || { RO: '40', MD: '373' };
  }

  function pregatesteTelefoane(form) {
    var selectoare = form.querySelectorAll('.abf-tel__tara');
    var harta = prefixe();

    /* Numele tarilor le da browserul, in romana. Fara Intl.DisplayNames raman
       doar codurile ISO, care sunt oricum de inteles. */
    var nume = null;
    try {
      nume = new Intl.DisplayNames(['ro'], { type: 'region' });
    } catch (e) {
      nume = null;
    }

    var coduri = Object.keys(harta).sort(function (a, b) {
      var fa = TARI_FRECVENTE.indexOf(a);
      var fb = TARI_FRECVENTE.indexOf(b);
      if (fa !== -1 || fb !== -1) return (fa === -1 ? 99 : fa) - (fb === -1 ? 99 : fb);
      var na = nume ? nume.of(a) || a : a;
      var nb = nume ? nume.of(b) || b : b;
      return na.localeCompare(nb, 'ro');
    });

    for (var i = 0; i < selectoare.length; i++) {
      var select = selectoare[i];
      var curent = select.value || 'RO';
      /* Golim prin removeChild, nu prin innerHTML: nu injectam nimic, iar asa e
         limpede la citire ca aici nu ajunge text din afara. */
      while (select.firstChild) select.removeChild(select.firstChild);

      for (var c = 0; c < coduri.length; c++) {
        var iso = coduri[c];
        var optiune = document.createElement('option');
        optiune.value = iso;
        optiune.textContent = iso + ' +' + harta[iso];
        optiune.title = nume ? nume.of(iso) || iso : iso;
        if (iso === curent) optiune.selected = true;
        select.appendChild(optiune);
      }
    }
  }

  /*
    Verificare de plauzibilitate, nu validare adevarata: numara cifrele si
    compara cu ce e normal pentru tara. Validarea reala o face serverul, cu
    libphonenumber. Aici nu incarcam biblioteca, ca sa nu punem 150 KB pe o
    pagina unde omul poate nici nu ajunge la formular.
  */
  function telefonPlauzibil(tara, text) {
    var cifre = (text || '').replace(/\D/g, '');
    if (!cifre) return false;

    /* Un 0 de inceput e prefixul national si nu intra in numarare. */
    if (cifre.charAt(0) === '0') cifre = cifre.slice(1);

    var prefix = prefixe()[tara];
    if (prefix && cifre.indexOf(prefix) === 0 && cifre.length > prefix.length + 5) {
      cifre = cifre.slice(prefix.length);
    }

    if (tara === 'RO') return cifre.length === 9;
    return cifre.length >= 6 && cifre.length <= 14;
  }

  function e164(tara, text) {
    var cifre = (text || '').replace(/\D/g, '');
    if (cifre.charAt(0) === '0') cifre = cifre.slice(1);

    var prefix = prefixe()[tara] || '';
    if (prefix && cifre.indexOf(prefix) === 0 && cifre.length > prefix.length + 5) {
      cifre = cifre.slice(prefix.length);
    }
    return '+' + prefix + cifre;
  }

  /* ------------------------------------------------------------------ contoare */

  function pregatesteContoare(form) {
    var contoare = form.querySelectorAll('[data-abf-count]');

    for (var i = 0; i < contoare.length; i++) {
      (function (contor) {
        var maxim = Number(contor.getAttribute('data-abf-count')) || 1000;
        var zona = contor.closest('[data-abf-field]').querySelector('textarea');
        if (!zona) return;

        function actualizeaza() {
          var ramase = maxim - zona.value.length;
          contor.textContent = ramase < 120 ? ramase + ' caractere ramase' : '';
        }

        zona.addEventListener('input', actualizeaza);
        actualizeaza();
      })(contoare[i]);
    }
  }

  /* -------------------------------------------------------------------- ciorna */

  /*
    Ce a scris omul se tine in sessionStorage, ca un refresh accidental pe telefon
    sa nu-l puna sa reia tot. Se sterge la trimitere reusita. Fisierele NU se
    salveaza (nici nu s-ar putea), iar bifa GDPR nu se restaureaza: un
    consimtamant trebuie dat de fiecare data, nu mostenit dintr-o ciorna.
  */
  function incarcaCiorna(form, slug) {
    var cheie = CHEIE_CIORNA + slug;
    var brut = null;
    try {
      brut = window.sessionStorage.getItem(cheie);
    } catch (e) {
      return;
    }

    if (brut) {
      try {
        var date = JSON.parse(brut);
        for (var nume in date) {
          if (!Object.prototype.hasOwnProperty.call(date, nume)) continue;
          var control = form.elements[nume];
          if (!control || control.type === 'checkbox' || control.type === 'file') continue;
          if (control.length && control[0] && control[0].type === 'radio') {
            for (var r = 0; r < control.length; r++) {
              if (control[r].value === date[nume]) control[r].checked = true;
            }
          } else if (typeof control.value === 'string') {
            control.value = date[nume];
          }
        }
      } catch (e) {
        /* Ciorna stricata nu are de ce sa opreasca formularul. */
      }
    }

    form.addEventListener('input', function () {
      var date = {};
      var elemente = form.elements;
      for (var i = 0; i < elemente.length; i++) {
        var el = elemente[i];
        if (!el.name || el.type === 'file' || el.type === 'checkbox') continue;
        if (el.name.charAt(0) === '_') continue;
        if (el.type === 'radio' && !el.checked) continue;
        date[el.name] = el.value;
      }
      try {
        window.sessionStorage.setItem(cheie, JSON.stringify(date));
      } catch (e) {
        /* Memorie plina sau mod privat. Nu e nimic de facut si nici de spus. */
      }
    });
  }

  function stergeCiorna(slug) {
    try {
      window.sessionStorage.removeItem(CHEIE_CIORNA + slug);
    } catch (e) {
      /* la fel */
    }
  }

  /* ------------------------------------------------------------------- afisare */

  function arataSucces(radacina, form, doneBox, mesaj) {
    if (doneBox) {
      if (mesaj) {
        var text = doneBox.querySelector('[data-abf-done-text]');
        if (text) text.textContent = mesaj;
      }
      doneBox.hidden = false;
    }
    form.hidden = true;

    /* Il ducem la confirmare: pe telefon, mesajul poate fi in afara ecranului. */
    if (doneBox && doneBox.scrollIntoView) {
      doneBox.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
    if (doneBox && doneBox.focus) {
      doneBox.setAttribute('tabindex', '-1');
      doneBox.focus({ preventScroll: true });
    }
  }

  function arataEsec(cutie, mesaj) {
    if (!cutie) return;
    cutie.textContent = mesaj;
    cutie.hidden = false;
  }

  function blocheazaButonul(buton, blocat) {
    if (!buton) return;
    buton.disabled = blocat;
    var text = buton.querySelector('[data-abf-submit-text]');
    if (!text) return;
    if (blocat) {
      buton.setAttribute('data-abf-text', text.textContent);
      text.textContent = 'Se trimite...';
    } else if (buton.getAttribute('data-abf-text')) {
      text.textContent = buton.getAttribute('data-abf-text');
    }
  }

  function curataUrl() {
    if (!window.history || !window.history.replaceState) return;
    var url = new URL(window.location.href);
    url.searchParams.delete('trimis');
    url.searchParams.delete('eroare');
    window.history.replaceState({}, '', url.toString());
  }

  function arata(el) {
    if (el) el.hidden = false;
  }

  function ascunde(el) {
    if (el) el.hidden = true;
  }
})();
